import AppRoutes from './routes/AppRoutes';
import { useAuthBootstrap } from './app/useAuthBootstrap';

export default function App() {
  // Resolves once, before any route renders — see useAuthBootstrap for why
  // this can't just be "check a cookie synchronously" the way a
  // traditional session-cookie app would.
  const bootstrapped = useAuthBootstrap();

  if (!bootstrapped) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent" />
      </div>
    );
  }

  return <AppRoutes />;
}
